import { useMutation } from '@tanstack/react-query'
import { setupNotifications } from '../../../containers/authentication/utils/setup-notifications'
import { useHistory } from 'react-router-dom'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import { authMutationKeys } from '../constants'

export const useLoginSamlMutation = () => {
  const { loginSuccessful, logout } = useAuthStore()
  const history = useHistory()

  const handleMutation = async ({ credentials }) => {
    try {
      setupNotifications(credentials)
      loginSuccessful(credentials)

      const redirectTo = localStorage.getItem('redirectTo')
      if (redirectTo) {
        localStorage.removeItem('redirectTo')
        history.replace(redirectTo)
      }

      history.replace('/')
    } catch (error) {
      logout()
      throw error
    }
  }

  return useMutation({
    mutationFn: async (credentials) => await handleMutation(credentials),
    mutationKey: authMutationKeys.SAML_MUTATION,
    retry: false
  })
}
